import DOMPurify from "dompurify";

/**
 * Sanitize job description HTML:
 * - Forbid all active/embedded content (script/iframe/object/etc)
 * - Strip inline styles/classes/ids and any on* event handlers
 * - Allow a conservative set of semantic tags and limited attributes
 * - Normalize links to open in a new tab with safe rel attributes
 */
export default function sanitizeHtml(input) {
  if (!input) return "";

  const ALLOWED_TAGS = [
    "a", "p", "br", "ul", "ol", "li",
    "strong", "em", "b", "i", "u",
    "blockquote", "code", "pre", "hr",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "table", "thead", "tbody", "tr", "th", "td"
  ];

  const ALLOWED_ATTR = [
    "href", "title", "target", "rel",
    "colspan", "rowspan", "scope"
  ];

  const clean = DOMPurify.sanitize(input, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Hard-block anything that could alter page styling or run scripts
    FORBID_TAGS: [
      "style", "script", "iframe", "object", "embed", "link", "meta",
      "form", "input", "button", "video", "audio", "svg", "math"
    ],
    FORBID_ATTR: [
      "style", "class", "id",
      "onload", "onerror", "onclick", "onmouseover", "onfocus", "onblur"
    ],
    RETURN_TRUSTED_TYPE: false
  });

  // Post-process links to enforce safe target/rel (no layout risk)
  const tmp = document.createElement("div");
  tmp.innerHTML = clean;
  tmp.querySelectorAll("a[href]").forEach((a) => {
    a.setAttribute("target", "_blank");
    a.setAttribute("rel", "noopener noreferrer nofollow");
  });

  return tmp.innerHTML;
}
